import { render, staticRenderFns } from "./mobileTableImpr.vue?vue&type=template&id=5a806cd7&scoped=true"
import script from "./mobileTableImpr.vue?vue&type=script&lang=js"
export * from "./mobileTableImpr.vue?vue&type=script&lang=js"
import style0 from "./mobileTableImpr.vue?vue&type=style&index=0&id=5a806cd7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a806cd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a806cd7')) {
      api.createRecord('5a806cd7', component.options)
    } else {
      api.reload('5a806cd7', component.options)
    }
    module.hot.accept("./mobileTableImpr.vue?vue&type=template&id=5a806cd7&scoped=true", function () {
      api.rerender('5a806cd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/ibm/mobileTableImpr.vue"
export default component.exports